import { render } from "./ControllerNameEditModal.vue?vue&type=template&id=30aefe47"
import script from "./ControllerNameEditModal.vue?vue&type=script&lang=js"
export * from "./ControllerNameEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__